import { useState } from "react";
import Markdown from "react-markdown";

/**
 * Renders LLM details text, splitting out <think> blocks into
 * a collapsible "Reasoning" section. Markdown is rendered.
 */
/** Collapse all double+ newlines to single newlines. */
function compact(s) {
  return s.replace(/\n{2,}/g, "\n");
}

export default function DetailsBody({ text }) {
  const [thinkOpen, setThinkOpen] = useState(false);

  if (!text) return null;

  const thinkMatch = text.match(/<think>([\s\S]*?)<\/think>/);
  const thinking = thinkMatch ? compact(thinkMatch[1].trim()) : null;
  const answer = compact(text.replace(/<think>[\s\S]*?<\/think>\s*/, "").trim());

  return (
    <div className="details-inline-body">
      {thinking && (
        <div className="details-think">
          <button
            className="details-think-toggle"
            onClick={() => setThinkOpen(!thinkOpen)}
          >
            {thinkOpen ? "▾" : "▸"} Reasoning
          </button>
          {thinkOpen && (
            <div className="details-think-content">
              <Markdown>{thinking}</Markdown>
            </div>
          )}
        </div>
      )}
      <div className="details-answer">
        <Markdown>{answer}</Markdown>
      </div>
    </div>
  );
}
